import callback1 from "../../utils/prototypeDefinitions/Date.prototype.addDays";
callback1();

const config = JSON.parse(localStorage.getItem("config/anniversaries") || "[]");

export const getAllAnniversaries = () => {
  const configWithRealFuncs = config.map((anni) => ({
    ...anni,
    dateFunc: new Function("date", anni.dateFunc),
  }));

  const anniversaries = [];

  let date = new Date();
  for (let i = 0; i < 366; i++) {
    configWithRealFuncs.forEach((anni) => {
      if (anni.dateFunc(date)) {
        anniversaries.push({
          title: anni.title,
          date: new Date(date),
          left: Math.floor((new Date(date).getTime() - Date.now()) / 8.64e7),
        });
      }
    });

    date = date.addDays(1);
  }

  return anniversaries;
};

export const getAnniversaries = () => {
  const anniversaries = getAllAnniversaries();

  const result = {
    thisMonth: [],
    farFuture: [],
    thisDays: [],
  };

  anniversaries.forEach((anni) => {
    const currentMonth = new Date().getMonth();
    const currentYear = new Date().getFullYear();
    if (
      anni.date.getMonth() === currentMonth &&
      anni.date.getFullYear() === currentYear
    ) {
      result.thisMonth.push(anni);
    } else if (anni.date < new Date().addDays(3)) {
      result.thisDays.push(anni);
    } else {
      result.farFuture.push(anni);
    }
  });

  return result;
};

// date transfromations
const toMonthDateAndMonthNumber = (date) =>
  `${date.getDate()} ${
    [
      "Січня",
      "Лютого",
      "Березня",
      "Квітня",
      "Травня",
      "Червня",
      "Липня",
      "Серпня",
      "Вересня",
      "Жовтня",
      "Листопада",
      "Грудня",
    ][date.getMonth()]
  } ${date.getFullYear()}`;

export const toBeautifullText = (date) => {
  const now = new Date();

  if (date.getMonth() === now.getMonth() && date.getDate() === now.getDate()) {
    return "Сьогодні";
  } else if (
    date.addDays(-1).getMonth() === now.getMonth() &&
    date.addDays(-1).getDate() === now.getDate()
  ) {
    return "Завтра";
  } else if (
    date.addDays(-2).getMonth() === now.getMonth() &&
    date.addDays(-2).getDate() === now.getDate()
  ) {
    return "Післязавтра";
  } else {
    return toMonthDateAndMonthNumber(date);
  }
};

export const notifyTodayBirthdays = (allAnniversaries) => {
  if (!window.Notification || Notification.permission !== "granted") {
    return;
  }

  const anniversaries = allAnniversaries.thisMonth;

  const today = anniversaries
    .filter((ann) => Date.isSameDay(new Date(), ann.date))
    .map((ann) => `- ${ann.title}`.slice(0, 38))
    .join(";\n");

  const tomorrow = anniversaries
    .filter((ann) => Date.isSameDay(new Date().addDays(1), ann.date))
    .map((ann) => `- ${ann.title}`.slice(0, 38))
    .join(";\n");

  let body = `${today && `Today:\n${today}`}\n${
    tomorrow && `Tomorrow:\n${tomorrow}`
  }`
    .trim("")
    .split("\n");

  if (body.length > 3) {
    body = body.slice(0, 3).join("\n") + "\nAND MORE";
  } else {
    body = body.join("\n");
  }

  if (body) {
    new Notification("Birthdays and Holidays", {
      body,
      requireInteraction: true,
      renotify: true,
      tag: "123",
    });
  }
};
